import React from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

import ContentCardList from "../../../Components/ContentCardList/ContentCardList";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import {
  MenuPageFeedback,
  MenuPageLoading,
} from "../MenuShared/MenuPageState";
import useNotifications from "../../../hooks/PortalAluno/useNotifications";
import MenuPageBackLink from "../MenuShared/MenuPageBackLink";
import "./styles.css";

const NotificationsPage = () => {
  const { data, error, isError, isLoading, isRefetching, refetch } =
    useNotifications();

  if (isLoading) {
    return (
      <section className="content-page notifications-page">
        <MenuPageLoading label="Carregando notificações" />
      </section>
    );
  }

  if (isError && !data) {
    return (
      <section className="content-page notifications-page">
        <PageHeader title="Notificações" />
        <MenuPageFeedback
          title="Não foi possível carregar as notificações"
          message={
            error instanceof Error && error.message !== "Network Error"
              ? error.message
              : "Verifique sua conexão e tente novamente."
          }
          onRetry={() => refetch()}
        />
      </section>
    );
  }

  const sections = (data ?? []).filter((section) => section.cards.length > 0);

  return (
    <section
      className="content-page notifications-page"
      aria-label="Notificações"
    >
      <MenuPageBackLink />

      <div className="menu-page-heading-row">
        <PageHeader
          title="Notificações"
          description="Novos conteúdos disponíveis para você, organizados por categoria."
        />
        <button
          type="button"
          className="menu-page-refresh"
          onClick={() => refetch()}
          disabled={isRefetching}
        >
          <RefreshRoundedIcon aria-hidden="true" />
          <span>{isRefetching ? "Atualizando…" : "Atualizar"}</span>
        </button>
      </div>

      {sections.length === 0 ? (
        <MenuPageFeedback
          empty
          title="Tudo em dia"
          message="Você não possui novas notificações no momento."
        />
      ) : (
        <div className="notifications-page__sections">
          {sections.map((section, index) => (
            <details
              key={section.key}
              className="notifications-section"
              open={index === 0}
            >
              <summary>
                <span>{section.title}</span>
                <span className="notifications-section__count">
                  {section.cards.length}
                </span>
                <ExpandMoreRoundedIcon aria-hidden="true" />
              </summary>
              <div className="notifications-section__content">
                <ContentCardList
                  title={`${section.title} Notificados`}
                  cards={section.cards}
                />
              </div>
            </details>
          ))}
        </div>
      )}
    </section>
  );
};

export default NotificationsPage;
